export enum SpouseInformationEnum {
  Current,
  New
}
